/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserStatisticsInfoVo
 */
export interface UserStatisticsInfoVo {
    /**
     * 优惠券数量
     * @type {number}
     * @memberof UserStatisticsInfoVo
     */
    couponCount?: number;
    /**
     * 未支付订单数量
     * @type {number}
     * @memberof UserStatisticsInfoVo
     */
    unpaidOrderCount?: number;
    /**
     * 留言数量
     * @type {number}
     * @memberof UserStatisticsInfoVo
     */
    siteMessageCount?: number;
    /**
     * 无数据快递数量
     * @type {number}
     * @memberof UserStatisticsInfoVo
     */
    nodataCount?: number;
}

/**
 * Check if a given object implements the UserStatisticsInfoVo interface.
 */
export function instanceOfUserStatisticsInfoVo(value: object): value is UserStatisticsInfoVo {
    return true;
}

export function UserStatisticsInfoVoFromJSON(json: any): UserStatisticsInfoVo {
    return UserStatisticsInfoVoFromJSONTyped(json, false);
}

export function UserStatisticsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserStatisticsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'couponCount': json['couponCount'] == null ? undefined : json['couponCount'],
        'unpaidOrderCount': json['unpaidOrderCount'] == null ? undefined : json['unpaidOrderCount'],
        'siteMessageCount': json['siteMessageCount'] == null ? undefined : json['siteMessageCount'],
        'nodataCount': json['nodataCount'] == null ? undefined : json['nodataCount'],
    };
}

export function UserStatisticsInfoVoToJSON(json: any): UserStatisticsInfoVo {
    return UserStatisticsInfoVoToJSONTyped(json, false);
}

export function UserStatisticsInfoVoToJSONTyped(value?: UserStatisticsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'couponCount': value['couponCount'],
        'unpaidOrderCount': value['unpaidOrderCount'],
        'siteMessageCount': value['siteMessageCount'],
        'nodataCount': value['nodataCount'],
    };
}

